import { About } from "Blocks/About";
import { Welcome } from "../Blocks/Welcome";
import { Services } from "Blocks/Services";
import {
  OriginalImageContainer,
  OriginalImageContentHorizontal,
  OriginalImageContentVertical,
} from "Image/style";
import { useState } from "react";
import { ImageLandscape, ImagePortrait } from "./style";
import { direction } from "Util/direction";
import { Gallery } from "Gallery";
import { Contact } from "Contact";
import { Feedback } from "Feedback";

export const Content = ({ setModalDialog }) => {
  const [imgSrc, setImgSrc] = useState({ src: "", direction: "" });

  return (
    <>
      <Welcome />
      <About setImgSrc={setImgSrc} />
      <Services setImgSrc={setImgSrc} />
      <Gallery setImgSrc={setImgSrc} />
      <Feedback />
      <Contact setModalDialog={setModalDialog} />
      {imgSrc !== undefined && imgSrc.src.length > 0 && (
        <OriginalImageContainer onClick={() => setImgSrc({ src: "" })}>
          {imgSrc.direction === direction.portrait && (
            <OriginalImageContentVertical>
              <ImagePortrait src={imgSrc.src} />
              {/* <OriginalImageCaption>Caption</OriginalImageCaption> */}
            </OriginalImageContentVertical>
          )}
          {imgSrc.direction === direction.landscape && (
            <OriginalImageContentHorizontal>
              <ImageLandscape src={imgSrc.src} />
              {/* <OriginalImageCaption>Caption</OriginalImageCaption> */}
            </OriginalImageContentHorizontal>
          )}
        </OriginalImageContainer>
      )}
    </>
  );
};
